import Tree from './src/tree'

export default Tree


// WEBPACK FOOTER //
// ./src/components/i-tree/index.js